import styled from "styled-components";

export const TitleMenu = styled.p``;

export const Container = styled.aside<{ isOpen: boolean }>`
    grid-area: AS;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;

    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: ${(props) => props.theme.colors.white};
    padding: 30px 0px;
    border: 2px solid  ${(props) => props.theme.colors.gray.gray_50};
    z-index: 1;
    
    width: ${({ isOpen }) => (isOpen ? '230px' : '70px')};
    transition: width 0.3s ease-in-out;
    
    ${TitleMenu}{
        display:  ${({ isOpen }) => (isOpen ? 'block' : 'none')};;
    }
    
    @media (max-width: 900px) {
        width: ${({ isOpen }) => (isOpen ? '90%' : '0px')}; 
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 90%;
    
    overflow: scroll;
    
    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const ContentImage = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const Image = styled.img`
    height: 55px;
`;

export const ContentMenu = styled.ol`
    width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 2px solid ${(props) => props.theme.colors.gray.gray_50};
  margin: 10px 0;
  padding-top: 10px;
`;


export const Menu = styled.li`
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 10px 20px;
    cursor: pointer;

    &.active{
        background-color: ${(props) => props.theme.colors.red.red_50};
        border-left: 5px solid ${(props) => props.theme.colors.primary};
        color: ${(props) => props.theme.colors.primary};
        padding-left: 15px;
    }
    
    svg{
        font-size: 20px;
    }
    
    &:hover{
        padding-left: 15px;
        background-color: ${(props) => props.theme.colors.red.red_50};
        color: ${(props) => props.theme.colors.primary};
        border-left: 5px solid ${(props) => props.theme.colors.primary};
    }

    &.div{
        display: flex;
        background-color: aqua;
    }

    transition: background-color 0.3s ease, color 0.3s ease;
`;

export const Tooltip = styled.div`
    position: absolute;
    left: 80%;
    margin-left: 8px;
    background-color: #333;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    font-size: 14px;
    z-index: 1000;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    justify-content: center;
    height: 10%;
    width: 100%;
`;

export const InforUser = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    p{
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
    
    span{ 
        color: ${(props) => props.theme.colors.gray.gray_200};
        font-size: 14px;
    }
`;

export const LogoUser = styled.p`
    display: flex;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.gray.gray_800};
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0px 4px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    font-weight: 600;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;

export const User = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    width: 100%;
    
    font-size: 16px;
    background-color: transparent;
    
    &:hover {
        color: ${(props) => props.theme.colors.primary};
        
        ${LogoUser} {
            background-color: ${(props) => props.theme.colors.red.red_50};
            color: ${(props) => props.theme.colors.primary};
            transform: scale(1.1);
            transition: transform 0.3s ease, background-color 0.3s ease;
        }
    }

    @media (max-width: 900px) {
        display: none;
    }
`;

//Botão menu responsivo
export const HamburgerButton = styled.button`
    display: none;
    position: absolute;
    top: 70px;
    left: auto;
    right: -30px;
    z-index: 100;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;
    padding: 5px;
    background-color: transparent;
    border-radius: 50%;

    svg{
        color: ${(props) => props.theme.colors.gray.gray_100};
        font-size: 20px;
    }

    @media (max-width: 900px) {
        display: flex;
    }

    &:hover{
        background-color: ${(props) => props.theme.colors.primary};
        svg{
            color: white;
        }
    }
`;

export const SubMenuWrapper = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  border-left: 4px solid ${(props) => props.theme.colors.gray.gray_100};

  &.visible {
    max-height: 250px;
  }
`;

export const ButtonMenu = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: blueviolet;

  background-color: transparent;
  padding: 10px 16px;
  
  svg {
    font-size: 20px;
    margin-right: 30px;
  }
  
  transition: 0.3s;
  
  &:hover {
    background-color: #f0f0f0;
  }

  p{
    font-size: 16px;
  }
`;

export const ContentDiv = styled.div`
    display: flex;
    align-items: center;
`;